<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li v-for="(value, idx) in values" :key="idx" class="breadcrumb-item">
        <a :data-qa="`page-header-breadcrumb-${idx}`" @click="navigateUrl(value.url)">
          <mp-text v-pixel="{ ':first-letter': { textTransform: 'capitalize' } }" font-size="sm" color="blue.400">{{
            value.label || value.title
          }}</mp-text>
        </a>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    values: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  methods: {
    navigateUrl(val) {
      if (val === 'back') this.$router.back();
      else this.$router.push(val);
    },
  },
};
</script>
